document.addEventListener("DOMContentLoaded", function () {

  if ('ontouchstart' in window) {
    return;
  }

  const mediaBoxes = document.querySelectorAll('.product__media');

  mediaBoxes.forEach(box => {

    const img = box.querySelector('img');

    if (!img) return;

    box.addEventListener('mousemove', function(e){

      const rect = box.getBoundingClientRect();

      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = "scale(2)";

    });


    box.addEventListener('mouseleave', function(){

      img.style.transform = "scale(1)";
      img.style.transformOrigin = "center center";

    });

  });

});